import NextHead from 'next/head';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'utils/with-i18next';
import GoogleIcon from '../assets/img/google-brands';
import Loading from '../components/Common/Loading';
import Layout from '../components/Layout';
import BASIC_CONSTANT from '../constants/basic.constants.js/basic.constants.js.js';
import UserActions from '../redux/UserActions';
import PageComponent from './PageComponent';

// 메타 정보 상수
const META = {
  title: 'BGMs - 로그인',
  description: 'BGMs (브금쓰)로 YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요.',
  url: 'https://bgms.live/login',
  image: 'https://bgms-bucket.s3.ap-northeast-2.amazonaws.com/channel/image/bgmsMetaImg.jpg',
};

class Login extends PageComponent {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.setState({ loading: false });
  }

  renderHead() {
    return (
      <NextHead>
        <title>{META.title}</title>
        <meta name="description" content={META.description} />
        <meta name="subject" content={META.description} />
        {/* Open Graph */}
        <meta property="og:title" content={META.title} />
        <meta property="og:description" content={META.description} />
        <meta property="og:url" content={META.url} />
        {/* Twitter */}
        <meta name="twitter:title" content={META.title} />
        <meta name="twitter:description" content={META.description} />
        <meta name="twitter:image" content={META.image} />
        <meta name="twitter:domain" content={META.url} />
      </NextHead>
    );
  }

  renderContent() {
    const { t, i18n } = this.props;
    const locale = i18n?.language || 'ko';

    // Determine policy page URLs based on locale
    const privacyUrl = locale === 'ko' ? '/policy/privacy' : `/policy/privacy-${locale}`;
    const serviceUrl = '/policy/service'; // Terms of Service is Korean-only

    return (
      <section className="flex items-center justify-center px-6 py-16 md:py-24">
        <div className="w-full max-w-sm">
          <h1 className="text-3xl font-bold text-white text-center mb-8">
            {t('h2')}
          </h1>

          <div className="bg-gray-900/80 border border-gray-800 rounded-xl p-6">
            <a
              id="btn-login"
              href={`${BASIC_CONSTANT.BASE_URL}${BASIC_CONSTANT.BACKEND_GOOGLE_AUTH_URL}`}
              className="flex items-center justify-center gap-3 w-full py-3 px-6 bg-white rounded-lg font-semibold text-gray-800 hover:bg-gray-100 transition-colors"
            >
              <GoogleIcon color="#1f2937" />
              <span>{t('continueGoogle')}</span>
            </a>

            <div className="my-5 border-t border-gray-700" />

            <p className="text-gray-400 text-xs text-center leading-relaxed break-keep whitespace-normal">
              {t('desc.1')}{' '}
              <a id="policy-1" href={privacyUrl} className="text-primary underline hover:text-white transition-colors">
                {t('desc.privacyPolicy')}
              </a>
              {' '}{t('desc.and')}{' '}
              <a id="policy-2" href={serviceUrl} className="text-primary underline hover:text-white transition-colors">
                {t('desc.termsOfUse')}
              </a>
              {t('desc.2')}
            </p>
          </div>
        </div>
      </section>
    );
  }

  render() {
    return (
      <Layout>
        {this.renderHead()}
        {this.state.loading ? <Loading /> : this.renderContent()}
      </Layout>
    );
  }
}

Login.propTypes = {
  UserRedux: PropTypes.object,
};

export default connect(
  state => state,
  (dispatch, ownProps) => {
    return { ...UserActions(dispatch, ownProps) };
  }
)(withTranslation('login')(Login));
